import { store } from '@/store/store';
import { appSetMessage } from '@/store/app';

export async function copyToClipboard(text: string) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed'; // Avoid scrolling to bottom
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }

    store.dispatch(appSetMessage({ text: 'Copied to clipboard!', type: 'success' }));
    return true;
  } catch {
    store.dispatch(appSetMessage({ text: 'Failed to copy to clipboard', type: 'error' }));
    return false;
  }
}